import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cepMask } from "../../mask";
import axios from "axios";
import clienteModel from "../../models/cliente";
import agendaModel from "../../models/agenda";
import usuarioModel from "../../models/usuario";
import queryString from "query-string";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
PouchDB.plugin(PouchdbFind);

export default class Empresa extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadEmpresas = this.loadEmpresas.bind(this);
    this.notificar = this.notificar.bind(this);

    this.state = {
      empresas: [],
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadEmpresas();
  }

  async loadEmpresas() {
    await axios
      .get(`${this.props.getBaseUrlApi()}/empresas`, this.props.parameters())
      .then((response) => {
        this.setState({
          empresas: response.data.empresas,
        });
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Empresas" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"empresas"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    width: "100%",
                                    backgroundColor: "#fafbfc",
                                  }}
                                >
                                  <table
              className="table table-hover table-striped"
              style={{ fontSize: "15px" }}
            >
                <thead className="thead-dark">
                <tr>
                  <th style={{}}>ID</th>
                  <th style={{}}>Descrição</th>
                  <th>CNPJ</th>
                  <th className="text-center">Vendedores</th>
                  <th className="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {this.state.empresas.map((empresa, key) => (
                  <tr key={key}>
                    <td>{empresa.idIntegracao}</td>
                    <td>{empresa.fantasia}</td>
                    <td>{empresa.cnpj}</td>
                    <td className="text-center">{empresa.totalVendedores}</td>
                    <td className="text-center">
                    
                        <i className="fa fa-line-chart" onClick={() =>
                          this.props.history.push(
                            `/empresas-meta?id=${empresa._id}`
                          )
                        }

                        id={`meta-empresa-${empresa._id}`}

                        
                        style={{cursor:"pointer", color:"green"}}></i>


<UncontrolledTooltip
                                                    placement="right"
                                                    target={`meta-empresa-${empresa._id}`}
                                                  >
                                                    Meta da Empresa
                                                  </UncontrolledTooltip>
                  
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
